import Store, { RootState } from "../../../redux/store";
import * as actions from "./auth.actions";
import { AuthState } from "../types/auth-state/auth-state.interface";
import { createSelector } from "reselect";

export function getAuthState(rootState: RootState): AuthState {
  return rootState.authState;
}

export const isAuthenticated = createSelector(
  getAuthState,
  (state: AuthState) => state.userId !== null
);

export const getUserId = createSelector(getAuthState, (state: AuthState) => state.userId);

export function authenticate() {
  Store.dispatch(actions.authenticate());
}
